import Swiper from 'swiper/bundle';

let _selectors = {
    slider: '.swiper-container',
    // navNext: '.swiper-button-next',
    // navPrev: '.swiper-button-prev',
};

// Cached Elements.
let _el = {};

// Module Variables
let _vars = {};

// Slider Instances
let _sliders = {};

// Module init
const _init = () => {
    // Define & Cache Elements
    _setElements();

    // Initialize sliders
    if (_vars.slider) {
        _initializeSliders();
        _attachNavSliders();
    }
};

// define function
// Handles the initialize of various slider types
const _initializeSliders = () => {
    $(_el.slider).each((i, el) => { 
        const $el = $(el);
        const sliderType = $el.data('slider-type');
        const sliderTypes = {
            BASE_SLIDER: 'baseCarousel',
            BLOCK_SLIDER: 'blockCarousel',
            FILE_SLIDER: 'fileCarousel',
            POST_SLIDER: 'postCarousel',
            TIMELINE_SLIDER: 'timelineCarousel',
            TIMELINENAV_SLIDER: 'timelineNavCarousel'
        }

        switch (sliderType) {
            case sliderTypes.BLOCK_SLIDER:
                _initBlockSlider($el);
                break;
            case sliderTypes.FILE_SLIDER:
                _initFileSlider($el);
                break;
            case sliderTypes.POST_SLIDER:
                _initPostSlider($el);
                break;
            case sliderTypes.TIMELINE_SLIDER:
                _initTimelineSlider($el);
                break;
            case sliderTypes.TIMELINENAV_SLIDER:
                _initTimelineNavSlider($el);
                break;
            default:
                _initBaseSlider($el);
                break;
        }
    });
}

/**
 * Initialize the Base Slider
 * @param {jQuery} $el Slider DOM element
 */
const _initBaseSlider = ($el) => {
    // Swiper config
    const config = {
        breakpoints: {
            769: {
                noSwiping: true,
                effect: 'fade',
                spaceBetween: 16,
            }
        },
        CSSWidthAndHeight: true,
        effect: 'slide',
        fadeEffect: {
            crossFade: true
        },
        grabCursor: true,
        loop: true,
        navigation: {
            nextEl: ".base_swiper-button-next",
            prevEl: ".base_swiper-button-prev",
        },
        preventClicksPropagation: true,
        slidesPerView: 1,
        spaceBetween: 16,
        speed: 700,
    }

    // Initialize and store swiper instance
    _sliders[$el.attr('id')] = new Swiper($el[0], config);
}

const _initPostSlider = ($el) => {

    // Swiper config
    const config = {
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        freeMode: false,
        grabCursor: false,
        allowTouchMove: false,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        
        preventClicks: false,
        preventClicksPropagation: false,
        slidesPerView: 1,
        spaceBetween: 16,
        speed: 500,
    }

    const configBefore = {
        ...config,
        effect: 'slide',
        grabCursor: true,
        speed: 1000,
        allowTouchMove: true,
    }
    _createResponsiveSlider($el.attr('id'), 768, configBefore, config);
}

const _initTimelineSlider = ($el) => {

    // Swiper config
    const config = {
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        freeMode: false,
        grabCursor: false,
        allowTouchMove: false,
        navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
        },
        preventClicksPropagation: false,
        slidesPerView: 1.2,
        spaceBetween: 16,
        speed: 500,
    }

    const configBefore = {
        ...config,
        effect: 'slide',
        grabCursor: true,
        speed: 1000,
        allowTouchMove: true,
    }
    _createResponsiveSlider($el.attr('id'), 768, configBefore, config);
}

const _initTimelineNavSlider = ($el) => {
    // Swiper config
    const config = {
        CSSWidthAndHeight: true,
        effect: 'slide',
        fadeEffect: {
            crossFade: true
        },
        breakpoints: {
            400: {
                slidesPerView: 4,
            }
        },
        grabCursor: true,
        loop: false,
        navigation: {
            nextEl: ".timeline-nav_swiper-button-next",
            prevEl: ".timeline-nav_swiper-button-prev",
        },
        preventClicksPropagation: false,
        slidesPerView: 3,
        speed: 700,
    }

    // Initialize and store swiper instance
    _sliders[$el.attr('id')] = new Swiper($el[0], config);
}

/**
 * Initialize the Base Slider
 * @param {jQuery} $el Slider DOM element
 */
const _initBlockSlider = ($el) => {
    // Check if slider is a region nav
    // const autoplay = $el.hasClass('region-horz-nav') ? false : {
    //     delay: 1500,
    //     pauseOnMouseEnter: true,
    // };

    // Swiper config
    const config = {
        autoplay: false,
        breakpoints: {
            769: {
                spaceBetween: 32,
                slidesPerView: 2.25,
            },
            1024: {
                spaceBetween: 48,
                slidesPerView: 2.25,
            }
        },
        freeMode: true,
        grabCursor: true,
        slidesPerView: 1.25,
        spaceBetween: 16,
        speed: 1250,
        navigation: {
            nextEl: ".slider-block_swiper-button-next",
            prevEl: ".slider-block_swiper-button-prev",
        },
    }

    // Initialize and store swiper instance
    _sliders[$el.attr('id')] = new Swiper($el[0], config);
}

/**
 * Initialize the File Navigator Slider
 * @param {jQuery} $el Slider DOM element
 */
const _initFileSlider = ($el) => {
    // Swiper config
    const config = {
        direction: 'vertical',
        freeMode: true,
        grabCursor: true,
        slidesPerView: 5,
        slidesPerGroup: 5,
        spaceBetween: 16,
        speed: 1200,
        navigation: {
            nextEl: ".slider-file_swiper-button-next",
            prevEl: ".slider-file_swiper-button-prev",
        },
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    }

    // Initialize and store swiper instance
    _sliders[$el.attr('id')] = new Swiper($el[0], config);
}

// Links navigation slider to its sibling slider
const _attachNavSliders = () => {
    $(_el.slider).each(function() {
        const navSliderID = $(this).attr('id');
        const mainSliderID = $(this).data('nav-for');

        if(mainSliderID && navSliderID) {
            const mainSlider = _sliders[mainSliderID];
            const navSlider = _sliders[navSliderID];

            if(mainSlider && navSlider){
                mainSlider.controller.control = navSlider;
                navSlider.controller.control = mainSlider;
            }

            // change img slider to index of hovered nav slide after delay.
            let timer;
            let delay = 500;

            $(navSlider.slides).on('mouseover', function() {
                const slideRef = $(this).index();

                timer = setTimeout(function() {
                    mainSlider.slideTo(slideRef);
                }, delay);
            });

            $(navSlider.slides).on('mouseout', function() {
                clearTimeout(timer);
            });
        }
    });

    
}

/**
 * Initializes a responsive slider on load and changes config at specified breakpoint on window resize
 * @param {string} id The ID of the dom element
 * @param {number} breakpoint The width at the sliders change
 * @param {object} configBefore The swiper options when window size is less than breakpoint
 * @param {object} configAfter The swiper options when window size is greater than breakpoint
 */
const _createResponsiveSlider = (id, breakpoint, configBefore, configAfter) => {
    _breakpointChecker(id, breakpoint, configBefore, configAfter);

    $(window).on('resize', function() {
        _breakpointChecker(id, breakpoint, configBefore, configAfter);
    });
}

/**
 * Handles the destroying and re-initializing of the swiper instances with updates to the config
 * @param {string} id The ID of the dom element
 * @param {number} breakpoint The width at the sliders change
 * @param {object} configBefore The swiper options when window size is less than breakpoint
 * @param {object} configAfter The swiper options when window size is greater than breakpoint
 */
const _breakpointChecker = (id, breakpoint, configBefore, configAfter) => {
    const media = window.matchMedia( `(min-width:${breakpoint}px)` );
    const slider = _sliders[id];

    // clean up old instances and inline styles when available
    if (slider !== undefined) {
        slider.destroy(true, true);
        _sliders[id] = undefined;
    }
    
    if (media.matches === true) {
        _sliders[id] = new Swiper(`#${id}`, configAfter);
    } else {
        _sliders[id] = new Swiper(`#${id}`, configBefore);
    }
};

// Set/Reset and Cache Module elements
const _setElements = () => {
    // Cache Elements into _el & create variable to check existence
    Object.keys(_selectors).forEach(key => {
        const el = document.querySelectorAll(_selectors[key]);
        _el[key] = el;
        _vars[key] = el.length;
    });
};

const Slider = {
    init: _init,
    getSlider: (id) => _sliders[id],
    getAllSliders: () => _sliders
};

// Make Slider globally available
// Used on post-looper.js
window.Slider = Slider;

export default Slider;